import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useRedirect from "@/hooks/useRedirect";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { LOGIN_WITH_PHONE_PAGE } from "@/settings/constant";
import { Button } from "@bookips/solvook-ui-library";
import { Typography, styled as muiStyled } from "@mui/material";
import React from "react";
import Icon from "../icon/Icon";
import { KakaoLoginIcon, Mobile, Sizes, WhaleIcon } from "../icon/IconList";
const SignInUp = {
    SIGNIN: "로그인",
    SIGNUP: "가입하기"
};
export const KakaoButton = (param)=>{
    let { type , onKakao  } = param;
    return /*#__PURE__*/ _jsx(KakaoLoginButtonWrapper, {
        children: /*#__PURE__*/ _jsx(Button, {
            variant: "solid",
            className: "login-btn",
            onClick: ()=>{
                onKakao();
                //mx-119, mx-121
                mixpanelEvent("".concat(SignInUp[type] === SignInUp.SIGNIN ? "Login" : "Sign Up", " Started"), {
                    "Button Name": "".concat(SignInUp[type] === SignInUp.SIGNIN ? "카카오로 로그인" : "카카오로 가입하기")
                });
            },
            label: /*#__PURE__*/ _jsxs(Typography, {
                variant: "semibold16",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: KakaoLoginIcon,
                        size: Sizes.small
                    }),
                    "카카오로 ",
                    SignInUp[type]
                ]
            })
        })
    });
};
export const PhoneButton = (param)=>{
    let { type , onPhone  } = param;
    const { redirectAgain  } = useRedirect();
    const handleClick = ()=>{
        redirectAgain(LOGIN_WITH_PHONE_PAGE);
        // mx-121
        mixpanelEvent("Login Started", {
            "Button Name": "휴대폰 번호로 로그인"
        });
    };
    return /*#__PURE__*/ _jsx(Button, {
        variant: "strokeSecondary",
        onClick: onPhone || handleClick,
        className: "login-btn",
        label: /*#__PURE__*/ _jsxs(Typography, {
            variant: "semibold16",
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    icon: Mobile,
                    size: Sizes.small
                }),
                "휴대폰 번호로 ",
                SignInUp[type]
            ]
        })
    });
};
export const WhaleButton = ()=>{
    const { redirectAgain  } = useRedirect();
    const onWhale = ()=>{
        // @todo redirect url이 붙는 작업 필요
        // mx-121
        mixpanelEvent("Login Started", {
            "Button Name": "웨일로 로그인"
        });
        redirectAgain(process.env.NEXT_PUBLIC_API_ENDPOINT + "/sessions/oauth/whale/authorize/");
    };
    return /*#__PURE__*/ _jsx(WhaleLoginButtonWrapper, {
        children: /*#__PURE__*/ _jsx(Button, {
            className: "whale-btn",
            onClick: onWhale,
            children: /*#__PURE__*/ _jsx(Icon, {
                icon: WhaleIcon
            })
        })
    });
};
export const SignInMain = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(SignInWrapper, {
        children: /*#__PURE__*/ _jsx("div", {
            children: children
        })
    });
};
export const SignIn = Object.assign(SignInMain, {
    KakaoButton: KakaoButton,
    PhoneButton: PhoneButton,
    WhaleButton: WhaleButton
});
export const SignInWrapper = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        maxWidth: "440px",
        height: "100%",
        minHeight: "600px",
        maxHeight: "800px",
        display: "flex",
        flexDirection: "column",
        padding: "60px 0",
        margin: "40px 0",
        background: "white",
        borderRadius: "12px",
        boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08), 0px 4px 8px 0px rgba(0, 0, 0, 0.04)",
        "> div": {
            display: "flex",
            flexDirection: "column",
            gap: "32px",
            margin: "0 40px",
            "&:not(:nth-of-type(1))": {
                marginTop: "16px"
            }
        },
        ".login-btn": {
            height: "56px",
            span: {
                display: "flex",
                alignItems: "center",
                gap: "8px"
            }
        },
        "&:hover": {
            borderColor: theme.palette.primary.main
        },
        "@media (max-width: 1200px)": {
            boxShadow: "none",
            padding: "32px 0",
            margin: "0"
        },
        "@media (max-width: 768px)": {
            "> div": {
                margin: "0 20px"
            }
        }
    };
});
export const WhaleLoginButtonWrapper = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        button: {
            width: "64px",
            height: "64px",
            padding: "0",
            borderRadius: "80px",
            border: "1px solid ".concat(theme.palette.grey[200])
        },
        "@media (max-width: 1200px)": {},
        "@media (max-width: 768px)": {}
    };
});
export const KakaoLoginButtonWrapper = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        button: {
            backgroundColor: "#fee500",
            width: "100%",
            height: "56px",
            display: "flex",
            gap: "8px",
            alignItems: "center",
            borderRadius: "6px",
            color: theme.palette.blackAndWhite.black,
            "@media (max-width: 1200px)": {},
            "@media (max-width: 768px)": {},
            "&:hover, &:active": {
                backgroundColor: "#F0DA11"
            }
        }
    };
});
